import React, { Component } from "react";
import classnames from "classnames";
import "./index.css";
import { Alert } from "antd";

class Page extends Component {
  render() {
    const {
      className,
      children,
      loading = false,
      inner = false,
      error = null,
    } = this.props;

    const loadingStyle = {
      height: "calc(100vh - 184px)",
      overflow: "hidden",
    };

    let errorMessage = "";
    if (error) {
      if (error.response) {
        if (
          error.response.data &&
          error.response.data.validationFailures &&
          Array.isArray(error.response.data.validationFailures)
        ) {
          errorMessage = error.response.data.validationFailures
            .map((el) => el.code)
            .join("<br />");
        } else if (error.response.status === 403) {
          errorMessage = error.response.data.error_description;
        } else if (error.response.status === 417) {
          errorMessage = error.response.data.content.message;
        } else if (error.response.status === 500) {
          errorMessage = `Oops, something went wrong(${error.response.data.error}). Please try again later`;
        } else if (error.response.status === 404) {
          errorMessage = `Sorry, requested recourse not found.`;
        }
      } else if (error.request) {
        errorMessage = error.request.responseText
          ? JSON.parse(error.request.responseText).error_description
          : error.request.statusText;
      } else if (typeof error === 'object') {
        // Handle form validation errors or other object errors
        if (error.message) {
          errorMessage = error.message;
        } else if (error.errorFields) {
          errorMessage = "Please check the form for validation errors.";
        } else {
          errorMessage = "An error occurred. Please try again.";
        }
      } else {
        errorMessage = String(error);
      }
    }

    return (
      <div
        className={classnames(className, {
          contentInner: inner,
        })}
        style={loading ? loadingStyle : null}
      >
        {error && (
          <Alert
            message="Error"
            description={errorMessage}
            type="error"
            showIcon
            closable
            style={{ marginBottom: 20 }}
            afterClose={() => this.props.onErrorDismissed && this.props.onErrorDismissed()}
          />
        )}

        {children}
      </div>
    );
  }
}

export default Page;
